export default __webpack_public_path__ + "static/media/fergus_page_three.81ae0815.svg";